"use strict";
/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const UnfoldMoreRounded_1 = __importDefault(require("@mui/icons-material/UnfoldMoreRounded"));
const textFieldAdornment = (icon, position = 'start') => {
    return icon ? react_1.default.createElement(material_1.InputAdornment, { position: position }, icon) : undefined;
};
/**
 * Label should shrink should be true based on these conditions
 * - When left icon is true or select is true
 * - When it focused it's always true
 * - When not focused and value is present or depends on base condition
 * @returns boolean
 */
const isShrink = (focused, value, leftIcon, select = false) => {
    const baseCondition = leftIcon !== undefined || select;
    if (focused) {
        return true;
    }
    return value ? true : baseCondition;
};
exports.TextField = (props) => {
    const { leftIcon, rightIcon, variant = 'filled', fullWidth = true, color = 'primary', margin = 'normal', select, value } = props, restProps = __rest(props, ["leftIcon", "rightIcon", "variant", "fullWidth", "color", "margin", "select", "value"]);
    const [focused, setFocused] = react_1.useState(false);
    return (react_1.default.createElement(material_1.TextField, Object.assign({ color: color, variant: variant, margin: margin, fullWidth: fullWidth, onFocus: () => setFocused(true), onBlur: () => setFocused(false), select: select, value: value || '', 
        // TODO: remove wrapper if shrink handled natively
        InputLabelProps: {
            shrink: isShrink(focused, value, leftIcon, select),
        }, InputProps: {
            startAdornment: textFieldAdornment(leftIcon),
            endAdornment: textFieldAdornment(rightIcon, 'end'),
        }, SelectProps: {
            variant: 'filled',
            IconComponent: UnfoldMoreRounded_1.default,
        } }, restProps)));
};
//# sourceMappingURL=data:application/json;base64,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